import { NextPage } from 'next';
import { layouts } from 'constants/layouts';
import ContactView from 'components/Contact/ContactView';
import { paths } from 'constants/paths';
import dynamic from 'next/dynamic';
import DefaultHead from '../../components/DefaultHead';

const OrderForm = dynamic(() => import('../../components/Form/OtherForm'), {
  ssr: false,
});

export const getStaticProps = async () => ({
  props: {
    layout: layouts.contact,
  },
});

const Other: NextPage = () => {
  return (
    <ContactView>
      <DefaultHead
        title="その他 - shizai"
        description="shizaiはオリジナルパッケージを低コスト・高品質で作れるプラットフォームです。ECで必要なパッケージの見積もりをかんたんに取得できます。"
        url={process.env.ORIGIN + paths.contactOther}
      />
      <OrderForm />
    </ContactView>
  );
};

export default Other;
